import { render, staticRenderFns } from "./ExtendingFinancialAssistance.vue?vue&type=template&id=21104027&"
import script from "./ExtendingFinancialAssistance.vue?vue&type=script&lang=js&"
export * from "./ExtendingFinancialAssistance.vue?vue&type=script&lang=js&"
import style0 from "./ExtendingFinancialAssistance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports